import { render } from "./PaywallTransactionDetailsModal.vue?vue&type=template&id=1d13186d"
import script from "./PaywallTransactionDetailsModal.vue?vue&type=script&lang=js"
export * from "./PaywallTransactionDetailsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__